export default __webpack_public_path__ + "static/media/acne.65ebc865.svg";